import {transparentize} from 'polished';
import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {hoverSelector} from '../../../../libs/shared/core/src/helpers/browser/hoverHelpers';

/*
 * Props.
 */

interface ContactCardActionsWrapperProps {
  className?: string;
}

/*
 * Style.
 */

const StyledItemActionsWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  position: absolute;
  top: 0;
  right: 0;
  padding-left: 16px;
  background: linear-gradient(
    to right,
    ${(p) => transparentize(1, p.theme.foreground)} 0%,
    ${(p) => p.theme.foreground} 16px
  );
  opacity: 0;

  ${hoverSelector} {
    opacity: 1;
  }
`;

/*
 * Component.
 */

export const ContactCardActionsWrapper: FC<PropsWithChildren<ContactCardActionsWrapperProps>> = ({
  children,
  className,
}) => <StyledItemActionsWrapperDiv className={className}>{children}</StyledItemActionsWrapperDiv>;
